module.exports = __webpack_public_path__ + "img/service7.a5057020.png";